import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

/** A selectable burner sub-component entry derived from tree data */
export interface BurnerSelectableComponent {
  positionId: number;
  label: string;
}

interface Props {
  /** Currently selected sub-component positionId (1=Block, 2=FrontFace, 3=WaterJacket, 4=Nozzle) */
  selectedPositionId: number;
  /** Callback when the user selects a different sub-component */
  onChange: (positionId: number) => void;
  /** Available burner sub-components derived from tree data */
  components: BurnerSelectableComponent[];
}

/**
 * Radio button group for selecting a burner sub-component.
 * Used in the 3D map view when a burner host mesh is clicked, since Block/FrontFace/Nozzle
 * share the same mesh and cannot be individually selected from the 3D model.
 * Water Jacket has its own mesh but is included here for consistency with the tree hierarchy.
 */
export const BurnerComponentSelector = ({
  selectedPositionId,
  onChange,
  components,
}: Props) => {
  return (
    <Box>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 600, mb: 1, display: "block" }}
      >
        Component
      </Typography>
      <RadioGroup
        row
        value={selectedPositionId}
        onChange={(_, value) => onChange(Number(value))}
        sx={{ gap: 1 }}
      >
        {components.map((comp) => (
          <FormControlLabel
            key={comp.positionId}
            value={comp.positionId}
            control={<Radio size="small" sx={{ py: 0.25 }} />}
            label={<Typography variant="body2">{comp.label}</Typography>}
            sx={{ ml: 0, mr: 0 }}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
